import {MatchResultEnum} from "@/modules/base/enums";
import {Incident, Match} from "@/modules/match/entity";
import {Player} from "@/modules/team/entity";
import LiveMatchEvaluator from "@/modules/match/services/LiveMatchEvaluator";

export const TYPES = {
  LiveMatchHandlers: Symbol.for('LiveMatchHandlers'),
};

export type FinishedMatch = {
  homeGoals: number,
  awayGoals: number,
  homeSkill: number,
  awaySkill: number,
  result: MatchResultEnum,
}

export type UnfinishedMatch = {
  homeGoals: undefined,
  awayGoals: undefined,
  homeSkill: undefined,
  awaySkill: undefined,
  result: undefined,
}

export type TickType = {
  evaluator: LiveMatchEvaluator
  match: Match,
  homePlayers: Player[],
  awayPlayers: Player[],
  incidents: Incident[],
  minute: number,
}

export type LiveIncidentType = TickType & {
  incident: Incident,
};

export type HomeAwayType = 'home' | 'away';
